module.exports = __webpack_public_path__ + "img/0-55.0c5ad6e0.jpg";